<template>
    <div v-if="relatedTable" class="w-100">

        <div class="d-flex mt-2">
            <div>
                <label><strong>{{field.name}}</strong></label>
            </div>
        </div>

        <div class="d-flex flex-wrap">
            <div v-for="documentId in linkedObjects" class="px-1 bd-highlight">
                <span class="badge text-bg-light">
                    <i class="fas fa-times pointer" @click="onRemoveClick(documentId)"></i>
                    {{fieldName(documentId)}}
                </span>
            </div>
        </div>

        <select class="form-select" v-model="selectedDocument" @change="onDocumentSelected">
            <option v-for="relatedDocument in relatedDocuments" :value="relatedDocument">
                {{fieldValue(relatedDocument)}}
            </option>
        </select>

    </div>
</template>

<script>
    import ModelService from "../services/ModelService";
    import DataService from "../services/DataService";
    import FormModal from "../views/form/FormModal.vue";

    export default {
        name: 'SelectRelatedObject',
        components: {FormModal},
        props: ['field', 'document', 'table'],
        data() {
            return {
                model: webase.model,
                service: new ModelService(),
                relatedTable: null,
                relatedDocuments: [],
                newDocument: null,
                selectedDocument: null,
                linkedObjects: []
            }
        },
        computed: {
            primaryField() {
                return webase.utils.table.getPrimaryField(this.relatedTable)
            }
        },
        mounted() {
            // this can happen when a Linked Object field is created after a document is created
            if(typeof this.document[this.field.index] === 'string' && this.document[this.field.index].length === 0) {
                this.document[this.field.index] = {}
            }

            this.linkedObjects = Object.keys(this.document[this.field.index])

            this.service.get(this.field.related_model_id).then((response) => {
                this.relatedTable = response
                this.loadRelatedData()
            }).catch((message) => {
                console.log('error loading related table')
                console.log(message)
            })
        },
        methods: {
            fieldValue(document) {
                return document[this.primaryField.index]
            },
            loadRelatedData() {
                let dataService = new DataService(this.relatedTable.id)

                dataService.get().then((response) => {
                    this.relatedDocuments = response
                }).catch((message) => {
                    console.log('error loading data from related table')
                    console.log(message)
                })
            },
            onDocumentSelected() {
                let relatedTable = this.document[this.field.index]
                relatedTable[this.selectedDocument['id']] = this.selectedDocument[this.primaryField.index]
                this.linkedObjects = Object.keys(this.document[this.field.index])
                this.selectedDocument = null
                webase.eventDispatcher.emit('onLinkedObjectSelected', this.document)
            },
            onRemoveClick(documentId) {
                console.log("removing doc: " + documentId)
                let relatedItems = this.document[this.field.index]
                delete relatedItems[documentId]
                this.linkedObjects = Object.keys(this.document[this.field.index])
                webase.eventDispatcher.emit('onLinkedObjectSelected', this.document)
            },
            fieldName(documentId) {
                let relatedItems = this.document[this.field.index]
                return relatedItems[documentId]
            }
        }
    }
</script>

<style>

</style>
